import axios from 'axios'
import endpoints from '../../endpoints'
import {StudentEnrollmentProps} from './types'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function studentEnrollment(body: StudentEnrollmentProps) {
  try {
    const response = await axios.post(API_URL + endpoints.student.studentEnrollment, body)
    return response.data
  } catch (error) {
    console.error('Error sending message:', error)
    throw error
  }
}
